import React from 'react';
import { useSelector } from 'react-redux';
import { getMarket } from '../selectors';
import Decimal from 'decimal.js-light';

import { getNumberFormatSeparators } from '../utils/l10n';

type Props = {
  market?: string;
  value: string | number | Decimal;
  decimals?: number;
  locale?: string;
};

const DEFAULT_DECIMALS = 0;

function getL10nNumber(
  market: string,
  value: string | number | Decimal,
  decimals = DEFAULT_DECIMALS,
  shouldDisplayOriginalValue = false,
) {
  // TODO Andres: add fallback for invalid input and handle edge cases
  const numberDecimal = new Decimal(value);
  const numberFormatted = shouldDisplayOriginalValue
    ? value.toString()
    : numberDecimal.toFixed(decimals);
  const parts = numberFormatted.split('.');
  const separators = getNumberFormatSeparators(market);
  // this approach only support thousands groups of 3 digits
  parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${separators.thousands}`);
  return parts.join(separators.decimals);
}

function L10nNumber({ market, value, decimals = DEFAULT_DECIMALS }: Props) {
  const marketFromStore = useSelector(getMarket)?.marketCode || '';
  return !value && value !== 0 ? null : (
    <span>{getL10nNumber(market || marketFromStore, value, decimals)}</span>
  );
}

L10nNumber.defaultProps = {
  decimals: DEFAULT_DECIMALS,
};

export default L10nNumber;

export { getL10nNumber };
